import { IInvoicePayment, IInvoiceData } from "@/types";
import InvoiceDataDefault from "../data/invoiceDefault";

export interface InvoiceState {
  invoicePayment: {} | IInvoicePayment;
  invoices: [] | IInvoiceData[];
  invoiceSelections: [] | IInvoiceData[];
}
export default {
  namespaced: true,
  state: {
    invoicePayment: {
      amountPaying: 0,
      amountDue: 0,
      docNumber: "",
      refNumber: "",
      id: ""
    },
    invoices: [],
    invoiceSelections: []
  } as InvoiceState,
  getters: {
    getInvoicePayment: (state: InvoiceState) => state.invoicePayment,
    getInvoiceData: (state: InvoiceState) => state.invoices,
    getInvoiceSelections: (state: InvoiceState) => state.invoiceSelections
  },
  mutations: {
    SET_INVOICE_PAYMENT(
      state: InvoiceState,
      newInvoicePayment: IInvoicePayment
    ) {
      state.invoicePayment = newInvoicePayment;
    },
    SET_INVOICE_DATA(state: InvoiceState, newInvoices: IInvoiceData[]) {
      state.invoices = newInvoices;
    },
    SET_INVOICE_SELECTIONS(
      state: InvoiceState,
      newInvoiceSelection: IInvoiceData[]
    ) {
      state.invoiceSelections = newInvoiceSelection;
    }
  }
};
